import { useCallback } from 'react';
import { useSelector } from 'core/common/hooks';
import { evalCondition } from 'core/common/utils/evalCondition';
import { ConditionDefinition, getConditionAttributes } from 'core/funnel/store/selectors';

type ConditionalFlowAttribute = {
  condition?: ConditionDefinition;
} & Record<string, unknown>;

export const useEvaluateConditionalAttributes = () => {
  const funnelConditions = useSelector(getConditionAttributes);

  const evaluateConditionalFlowAttributes = useCallback(
    <A extends Array<ConditionalFlowAttribute>>(attributes: A | undefined): A[number] | null => {
      if (!attributes) {
        return null;
      }

      const firstAttributeWithMetCondition = attributes.find((attribute) => {
        if (attribute.condition) {
          return [funnelConditions].find(evalCondition(attribute.condition));
        }
      });

      if (!!firstAttributeWithMetCondition) {
        const { condition: _, ...restAttributes } = firstAttributeWithMetCondition;
        return restAttributes;
      }

      const lastAttribute = attributes[attributes.length - 1];

      return lastAttribute ?? null;
    },
    [funnelConditions],
  );

  return evaluateConditionalFlowAttributes;
};
